import { render, staticRenderFns } from "./KycProofOfBank.vue?vue&type=template&id=66199c46&scoped=true&"
import script from "./KycProofOfBank.vue?vue&type=script&lang=js&"
export * from "./KycProofOfBank.vue?vue&type=script&lang=js&"
import style0 from "./KycProofOfBank.vue?vue&type=style&index=0&id=66199c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66199c46",
  null
  
)

export default component.exports